import { defineMessages } from 'react-intl'

export type SearchVertical = 'all' | 'hotels' | 'homes'

export const HOTEL_PROPERTY_TYPE = 'hotel_resorts'
export const HOME_PROPERTY_TYPES = [
  'homes_villas',
  'apartments',
  'bed_breakfast',
  'guesthouse',
  'unique_escapes',
]

export const SEARCH_VERTICAL_TAB_OPTIONS: Array<SearchVertical> = ['all', 'hotels', 'homes']

export const SEARCH_VERTICAL_TAB_MESSAGES = defineMessages({
  all: {
    id: 'qlVsl-REvmtRV6YkHwr4',
    defaultMessage: 'All Stays',
  },
  hotels: {
    id: 'meqJz1yKTBbmPVKxgp-z',
    defaultMessage: 'Hotels',
  },
  homes: {
    id: 'oCTuc5TE-kf1PCbhKd5w',
    defaultMessage: 'Homes',
  },
})
